<template>
  <div class="shopList">
    <van-list
      :loading="allshopLoaing"
      :finished="allshopFinished"
      :offset="0"
      finished-text="没有更多了"
      @load="onLoad">
      <ul>
        <li v-for="shops in shopsList" :key="shops.shopsId" @click="toShop(shops.shopIds)">
          <!-- `/vm/shop/${shops.shopIds}` -->
          <div class="shop_image">
              <van-image lazy-load v-if="shops.face" :src="`${shops.face}?imageView2/1/w/180/h/180`" alt=""></van-image>
              <van-image lazy-load v-else src="https://filesouthcdn.nxin.com/nxsc_150277595667202204185653403551.png?imageMogr2/auto-orient/thumbnail/1200000@" alt=""></van-image>
          </div>
          <div class="shop_main">
            <p class="shop_name ellipsis gray3 f14_rem">{{shops.name}}</p>
            <van-rate
              v-model="shops.shopLevel"
              :size="10"
              color="#F5BE41"
              void-icon="star"
              void-color="#eee"
            />
            <p class="shop_label">
              <span class="shop_label_item" v-if="shops.isFactoryDirect === '1'">厂家品牌店</span>
              <span class="shop_label_item" v-if="shops.isnxyy === '1'">运营中心旗舰店</span>
              <span class="shop_label_item" v-if="shops.isnxyy === '2'">运营中心试运营</span>
              <span class="shop_label_item" v-if="shops.isCoreEnterprise === '1'">核心企业旗舰店</span>
              <span class="shop_label_item" v-if="shops.isDealership === '1'">经销店</span>
              <span class="shop_label_item" v-if="shops.isNongxinStation === '1'">农信小站</span>
            </p>
            <p class="shop_addr">
              <img class="good_cart" src="./images/shop-addr.png" alt="">
              <span class="f12_rem gray6 ellipsis">{{shops.areaName}}{{shops.addr}}</span>
            </p>
          </div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {

  data() {
    return {
      pageNum: 1,
      shopsList: [],
      allshopLoaing: false,
      allshopFinished: false,
      allLoading: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    userIdentity: state => state.app.userIdentity
  }),
  created() {
    console.log("userIdentity", this.userIdentity);
    this.getshopsList();
  },
  methods: {
    // 上拉加载
    onLoad() {
      if (this.shopsList.length) {
        this.allshopLoaing = true;
        this.pageNum += 1;
        this.getshopsList();
      }
    },

    // 获取商品列表
    getshopsList() {
      const { pageNum, shopsList } = this;
      const { ID, Type } = this.userIdentity;
      // Type 1 — 个人 0 — 企业
      const busType = Type === 1 ? "1" : "2";
      this.$store.dispatch("goods/goods/getDsjapiList", {
        page: pageNum,
        page_size: 18,
        use_customer: 1,
        use_favorite: 1,
        in_business_id: ID,
        in_business_type: busType,
        out_business_type: 7,
        tracking_code: "app_znt_haodian_youpin"
      }).then((data) => {
        this.allshopLoaing = false;
        this.shopsList = shopsList.concat(data || []);
        if (!data.length) {
          this.allshopFinished = true;
        }
      });
    },

    // 点击跳转详情
    toShop(shopIds) {
      this.$router.push(`/shop/${shopIds}`);
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
